import React from 'react';
import * as LucideIcons from 'lucide-react';
import { HelpCircle } from 'lucide-react';

const Icon = React.memo(function Icon({
  name,
  size = 24,
  color = 'currentColor',
  className = '',
  strokeWidth = 1.75,
  ...props
}) {
  const IconComponent = LucideIcons?.[name];

  if (!IconComponent) {
    return (
      <HelpCircle
        size={size}
        color="gray"
        strokeWidth={strokeWidth}
        className={className}
        {...props}
      />
    );
  }

  return (
    <IconComponent
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      className={className}
      {...props}
    />
  );
});

export default Icon;
